module.exports = __webpack_public_path__ + "img/800ad5a.jpg";